import SelfAssemblyProductItemSidebar from "entities/product-item-sidebar/SelfAssemblyProductItemSidebar";
import { OrderProduct } from "shared/api/middleware-api-client";
import Container from "shared/ui/container";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

interface SidebarProductsListProps {
  products: OrderProduct[];
}
const SelfAssemblySidebarProductsList = ({
  products,
}: SidebarProductsListProps) => {
  if (products.length <= 0)
    return (
      <Container className="gg-px-4 sm:gg-px-14 md:gg-px-32 lg:gg-px-14 xl:gg-px-32">
        <Text>Geen products.</Text>
      </Container>
    );

  return (
    <>
      {products.map((product, id) => {
        return (
          <div
            key={`product-${id}`}
            className={concatClassnames(
              "gg-grid gg-grid-cols-12 gg-items-start",
              id !== products.length - 1 && "gg-border-b",
              id !== 0 && "gg-pt-9",
              id !== products.length - 1 ? "gg-pb-9" : "gg-pb-2",
            )}
          >
            <SelfAssemblyProductItemSidebar product={product} />
          </div>
        );
      })}
    </>
  );
};
export default SelfAssemblySidebarProductsList;
